import { Component, Inject, OnInit, Optional } from '@angular/core';
import { PermissionCheckerService, PershingTranslationService } from '@pershing/pershing-core';
import { settingsNavigation } from '../utils/settingsnavigation.constants';

@Component({
    selector: 'all-settings',
    templateUrl: './all-settings.component.html'
})
export class AllSettingsComponent implements OnInit {

    allsettings: any[] = [];
    deviceType: string = 'desktop';
    suppressGoPaperless: boolean = false;
    isVendorSso: boolean;
    isAdvisor: boolean;
    isModernThemeOnly: boolean = false;
    isSpanishEnabledIBD: boolean = false;
    isGeneric: boolean = false;

    constructor(
        private translationService: PershingTranslationService,
        private authorizationService: PermissionCheckerService,
        @Optional() @Inject('AppSettings') appSettings: any) {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-modern-navigation', 'node_modules/@pershing/nxi-ng-modern-navigation/lib');
        if (!!appSettings && !!appSettings.deviceType) {
            this.deviceType = appSettings.deviceType;
        }
        if (appSettings.ibdConfigMap && appSettings.ibdConfigMap.suppressGoPaperless) {
            this.suppressGoPaperless = appSettings.ibdConfigMap.suppressGoPaperless;
        }
        if (appSettings.isVendorSso) {
            this.isVendorSso = appSettings.isVendorSso;
        }
        if (appSettings.isAdvisor) {
            this.isAdvisor = appSettings.isAdvisor;
        }
        this.isModernThemeOnly = appSettings.ibdConfigMap.isModernThemeOnly ? true : false;
        this.isGeneric = appSettings.ibdConfigMap.generic;
        let spanishSiteEnabledIBDs = appSettings.ibdConfigMap.spanishSiteEnabledIBD;
        if (spanishSiteEnabledIBDs && spanishSiteEnabledIBDs.includes(appSettings.ibdConfigMap.IBD) || (this.isGeneric && appSettings.ibdConfigMap.community === 'netxinvestor')) {
            this.isSpanishEnabledIBD = true;
        }
    }

    ngOnInit(): void {
        settingsNavigation.allSettings.forEach(tile => {
            if (tile.id == 'display' && (this.isModernThemeOnly && !this.isSpanishEnabledIBD)) {
                return;
            }
            if (tile.id == 'edelpreferences' && this.suppressGoPaperless) {
                return;
            }
            if (tile.id == 'security' && (this.isVendorSso || this.isAdvisor)) {
                return;
            }
            this.checkEntitlement(tile);
        });
        this.allsettings = settingsNavigation.allSettings;
    }

    navigateToPage(page: any): void {
        document.dispatchEvent(new CustomEvent('portal.gotoview', {
            detail: {
                'gotoPage': page.url
            }
        }));
    }

    checkEntitlement(tile) {
        if (tile.entitlements == 'ANY') {
            tile.isEntitled = true;
        } else {
            tile.isEntitled = this.authorizationService.isEntitled(tile.entitlements);
        }
    }
}
